<template>
  <button
    @click="$store.commit('openLanguageSwitcher')"
    class="h-10 sm:h-12 px-3 py-2 sm:px-6 sm:py-3 m-6 md:m-12 rounded-full bg-black flex flex-row items-center"
  >
    <the-language-switcher-icon class="w-4 h-4 sm:w-6 sm:h-6" />
    <span class="text-white uppercase text-sm sm:text-base ml-2 sm:ml-4 mt-1" style="margin-top: 2px"> Menu </span>
  </button>
</template>

<script>
import TheLanguageSwitcherIcon from "./TheLanguageSwitcherIcon";

export default {
  name: "TheLanguageSwitcher",
  components: {
    TheLanguageSwitcherIcon,
  },
};
</script>

<style lang="css" scoped>
</style>